export class HealthPolicyRecipient {
  constructor(
    public name: string,
    public mobileNumber: string,
    public email: string,
    public message: string,
    public design: string
  ) { }
}
